import { createMachine, assign } from 'xstate';
import { PreOrderPayload } from '@fingermarkglobal/types';
import { loyaltyPossibleRedemptions } from '../requests/loyalty-possible-redemptions';

const populateMessage = assign({
  data: (_, payload: any) => {
    const message = payload?.message;
    const error = message?.message;
    const data = payload?.data;

    if (data) {
      logger.debug(`api - loyaltyPossibleRedemptions - FSM data recieved:`, data);
      return data;
    }

    if (error) {
      logger.error(`api - loyaltyPossibleRedemptions - FSM error recieved:`, error);
      return error;
    }

    logger.error(`api - loyaltyPossibleRedemptions - FSM message recieved:`, message);
    return message;
  },
});

const createLoyaltyPossibleRedemptionsMachine = ({
  token = '',
  transactionId = '',
  payload = null,
  promoId = '',
} = {}) =>
  createMachine<{
    token: string;
    transactionId: string;
    payload: any | PreOrderPayload;
    promoId: string;
  }>(
    {
      id: 'loyaltyPossibleRedemptions',
      initial: 'processing',
      context: {
        token,
        transactionId,
        payload,
        promoId,
      },
      states: {
        processing: {
          invoke: {
            // eslint-disable-next-line no-shadow
            src: ({ token, transactionId, payload, promoId }) => {
              const canProcess = token && transactionId && promoId;

              if (!canProcess) {
                return Promise.resolve({
                  redemptions: [],
                  amount: 0,
                });
              }

              return loyaltyPossibleRedemptions({ token, transactionId, payload, promoId });
            },
            onDone: {
              target: 'success',
              actions: ['populateMessage'],
            },
            onError: {
              target: 'error',
              actions: ['populateMessage'],
            },
          },
        },
        success: {
          on: {
            IDLE: 'processing',
          },
        },
        error: { type: 'final' },
      },
    },
    {
      actions: {
        populateMessage,
      },
    },
  );

export { createLoyaltyPossibleRedemptionsMachine };
